import React from "react";
import { Waves, TreePine, GraduationCap, Bus, ShoppingBag, Footprints } from "lucide-react";
import SectionWave from "./SectionWave";

const AMENITIES = [
  { icon: Waves, title: "Two ponds" },
  { icon: Footprints, title: "Walking trails" },
  { icon: GraduationCap, title: "Schools nearby" },
  { icon: TreePine, title: "Parks & playgrounds" },
  { icon: ShoppingBag, title: "Shopping & services" },
  { icon: Bus, title: "Easy transit" },
];

// Full-bleed light band with the animated home-page wave on both edges.
// Icon + title only. Place inside a max-width container; it breaks out to full width.
export const AmenitiesStrip = () => (
  <div data-testid="stage-amenities" className="relative left-1/2 -translate-x-1/2 w-screen my-24 md:my-32 bg-[#F3EEE3] text-[#12201A]">
    <SectionWave position="top" color="#F3EEE3" />
    <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-14 md:py-20">
      <p className="eyebrow text-[#9A8558] mb-2">Life at Deer Park</p>
      <h2 className="font-display text-2xl md:text-3xl text-[#12201A] mb-8">A community built around the outdoors</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-8">
        {AMENITIES.map((a, i) => {
          const Icon = a.icon;
          return (
            <div key={i} data-testid={`amenity-${i}`} className="flex flex-col items-center text-center">
              <div className="w-14 h-14 rounded-2xl bg-[#12201A]/[0.07] flex items-center justify-center mb-3">
                <Icon size={24} className="text-[#3E7A5E]" />
              </div>
              <p className="text-[#12201A] font-medium text-sm leading-snug">{a.title}</p>
            </div>
          );
        })}
      </div>
    </div>
    <SectionWave position="bottom" color="#F3EEE3" />
  </div>
);

export default AmenitiesStrip;
